<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2661 4.60059L4.59945 11.2673" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <path d="M4.6001 4.60059L11.2668 11.2673" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>